import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { GameEstimates } from '../../estimates'
import { TableRowUpdateImpact } from '../../update-impacts/types/TableRowUpdateImpact'

export const useOpenUpdateModal = (gameEstimates: GameEstimates[]) => {
  const location = useLocation()
  const navigate = useNavigate()

  const handleOpenUpdateClicked = useCallback(
    (update: TableRowUpdateImpact) => {
      // Prefer the market of the clicked row itself; the same game can be compared in multiple markets,
      // in which case the game id alone always resolves to the first instance's market (GR-1332)
      const selectedMarketIso = update.marketIso || gameEstimates?.find(({ game }) => game.id === update.gameId)?.marketIso
      navigate(`${location.pathname}/gameupdate/${update.gameId}/${update.version}/${selectedMarketIso}`, {
        state: { ...(location.state as Record<string, unknown>), skipScrollToTop: true },
      })
    },
    [gameEstimates, navigate, location.pathname, location.state]
  )
  return { handleOpenUpdateClicked }
}
